import { getSquadMode } from "core-integration/src/store/squad/reducers";
import Link from "plos/src/components/links/Link/Link";
import { copy } from "plos/src/styles/copy.css";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";

const TransfersHelp = () => {
  const mode = useSelector(getSquadMode);

  return (
    <div className={copy}>
      {mode === "transfers" && (
        <Trans ns="help" i18nKey="contextualHelp.transfers.description1">
          <p>
            You are given one free transfer per Gameweek. Additional transfers
            in a Gameweek deduct 4 points from your Gameweek score; this is
            often referred to as taking a “points hit”.
          </p>
        </Trans>
      )}
      {mode === "selection" && (
        <Trans ns="help" i18nKey="contextualHelp.transfers.description2">
          <p>
            You currently have infinite transfers but once the season begins you
            will get one free transfer per Gameweek. Additional transfers you
            make in a Gameweek will cost you 4 points from your Gameweek total,
            this is often referred to as taking a “points hit”.
          </p>
        </Trans>
      )}
      <Trans ns="help" i18nKey="contextualHelp.transfers.description3">
        <p>
          If you do not use your free transfer, you can roll it over and make an
          additional free transfer in the following Gameweek. Free transfers can
          be rolled over to a maximum of five in a Gameweek.
        </p>
        <p>
          Player prices change throughout the season depending on their
          ownership, or popularity, and these changes happen at midnight UK time
          each day.
        </p>
        <Link
          href={`${
            import.meta.env.VITE_HF_BASE
          }/en/news/2174907/fpl-basics-making-transfers`}
        >
          FPL Basics Explained: How to make transfers
        </Link>
      </Trans>
    </div>
  );
};

export default TransfersHelp;
